import { tw } from '@backmarket/utils/string/tw'

export type TextColor = 'Black' | 'White'

export const colorClasses: Record<TextColor, string> = {
  Black: tw`text-static-default-hi`,
  White: tw`text-static-light-hi`,
}
